export const effects = {
  opacity: {
    disabled: '40%',
    sm: '20%',
    md: '50%',
    lg: '80%'
  },
  boxShadow: {
    'rule-01': '0px 0px 6px rgba(0, 0, 0, 0.10)',
    'rule-02': '0px 0px 5px rgba(224, 10, 23, 0.15)',
    card: '0px 1px 3px 0px rgba(51, 69, 96, 0.20)'
  }
} as const
